const getDefaultState = () => {
  return {
    list: [],
    customers: []
  }
}

const state = getDefaultState()

const getters = {
  getById: ({ list }) => id => {
    return list.find(product => parseInt(product.id) === parseInt(id))
  }
}

const mutations = {
  updateList(state, newList) {
    state.list = newList
  },

  updateItem(state, updatedItem) {
    const index = state.list.findIndex(item => item.id === updatedItem.id)
    if (index !== -1) {
      state.list.splice(index, 1, updatedItem)
    }
  }
}

const actions = {
  fetchProduct(context, { id }) {
    let product = context.getters.getById(id)
    return product
  },

  updateItem({ commit }, updatedItem) {
    commit('updateItem', updatedItem)
  },

  updateList({ commit }, newList) {
    commit('updateList', newList)
  },
}

export default () => ({
  namespaced: true,
  actions,
  getters,
  mutations,
  state
})
